import React, { useState, useEffect } from 'react';
import { Card, Button, message, Checkbox } from 'antd';
import { isEmpty } from 'script/common';

const CommonAppLogo = ({ t, onFileSelect, fileKey, settingData }) => {
	const [selectedFile, setSelectedFile] = useState({});

	const handleFileChange = (e) => {
		const file = e.target.files[0];

		// 파일 입력 초기화
		e.target.value = null;

		if (file) {
			// 파일 크기 제한 체크 (2MB 미만)
			if (file.size > 2 * 1024 * 1024) {
				message.error(t('settings.msg.invalidLogoImage'));
				return;
			}

			// 파일 포맷 체크 (svg, png, jpeg, webp)
			const validFormats = ['image/svg+xml', 'image/png', 'image/jpeg', 'image/webp'];
			if (!validFormats.includes(file.type)) {
				message.error(t('settings.msg.invalidLogoImageFormat'));
				return;
			}

			setSelectedFile(file);
			onFileSelect({ [fileKey]: file });
		}
	};

	const handleFileRemove = () => {
		setSelectedFile(null);
		onFileSelect({ [fileKey]: null });
	};

	const getLogoFileName = () => {
		if(!selectedFile) {
			return t('settings.msg.noFileChosen');
		}
		if (!settingData?.appLogoImage?.fileName && !isEmpty(selectedFile)) {
			return selectedFile.name
		}
		if (!settingData?.appLogoImage?.fileName && isEmpty(selectedFile)) {
			return t('settings.msg.noFileChosen');
		}
		if (settingData?.appLogoImage?.fileName && !isEmpty(selectedFile)) {
			return selectedFile.name;
		}
		if (settingData?.appLogoImage?.fileName && isEmpty(selectedFile)) {
			return settingData?.appLogoImage?.fileName;
		}
	};

	return (
		<div>
			<Card type="inner" title="Common" style={{ margin: 20 }}>
				<div>
					<label id={`label_file_${fileKey}`} style={{ margin: 20 }}>
						{getLogoFileName()}
					</label>
					<input
						type="file"
						accept=".svg, .png, .jpg, .jpeg, .webp"
						id={`logo_image_${fileKey}`}
						onChange={handleFileChange}
						style={{ display: "none" }}
					/>
					<Button onClick={() => document.getElementById(`logo_image_${fileKey}`).click()}>
						{t('settings.button.browseFile')}
					</Button>
					<Button
						type="default"
						onClick={handleFileRemove}
						style={{ marginLeft: 10 }}
						disabled={isEmpty(selectedFile) && !settingData?.appLogoImage?.fileName}
					>
						{t('settings.button.removeFile')}
					</Button>
				</div>
			</Card>
		</div>
	);
};

export default CommonAppLogo;